import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteCourseOverridesQuery({
  courseId,
  overridesActiveScope = 'all',
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['courseOverrides', courseId, overridesActiveScope],
    queryFn: async ({ pageParam = 1 }) => {
      const courseOverridesResponse = await axios.get(
        `/courses/${courseId}/overrides`,
        {
          params: {
            active_scope: overridesActiveScope,
            page: pageParam,
          },
        },
      );

      return courseOverridesResponse.data;
    },
    getNextPageParam,
    select: (data) =>
      formatInfiniteData({
        data,
        resourceTypes: [
          'personnel',
          'personnelCourseConnectionRequirementPriority',
          'profilePhoto',
          'simpleUser',
          'userCourse',
        ],
      }),
    ...queryOptions,
  });
}
